import angular from 'angular'

import { uniqueId } from 'lodash-es'

import strictOnce from '../utils/strict-once'

angular
  .module('ggs.gallery-styler-new')
  .factory('GalleryStylerNew', GalleryStylerNewProvider)

function GalleryStylerNewProvider(
  $q,
  qh,
  DefineMethod,
  DefineHandler,
  GSNServerManager,
  GSNInspectManager) {

  return function GalleryStylerNew(properties) {

    const sign = `stylerNew[uid=${uniqueId()}]`
    const styler = {}

    styler.wrapH = DefineHandler(sign)
    styler.wrapM = DefineMethod(sign)

    styler.server = GSNServerManager(styler)
    styler.inspector = GSNInspectManager(properties)

    // init/destroy

    styler.wrapM('init', strictOnce(
      qh.makeJoin(
        styler.server.init,
        styler.inspector.init)))

    styler.wrapM('destroy', strictOnce(
      qh.makeJoin(
        styler.server.destroy,
        styler.inspector.destroy)))

    // getStyle

    styler.wrapM('getStyle', ({ style }) =>
      properties.get(style))

    // applyStyle

    styler.wrapM('applyStyle', ({ style, value }) =>
      properties.set(style, value))

    // applyBatch
    styler.wrapM('applyBatch', (batch) =>
      properties.set(batch))

    // delta

    styler.wrapM('delta', ({ clientId, lastDeltaId }) =>
      styler.inspector.delta(clientId, lastDeltaId))

    // release

    styler.wrapM('release', (handlers) =>
      $q.all(handlers.map(releaseOne)))

    function releaseOne(handler) {
      handler.propKeys.forEach((propKey) =>
        properties.key2emitter[propKey].off(handler.callHandler))

      handler.destroyed = true
      return handler.destroy()
    }

    // reg

    styler.wrapM('reg', (handlers) =>
      $q.all(handlers.map(regOne)))

    function regOne(handler) {
      handler.callHandler = callHandler

      for (const propKey of handler.propKeys) {
        properties.key2emitter[propKey].after(handler.callHandler)
      }

      return handler.callHandler()

      function callHandler() {
        const values = handler.propKeys.map(properties.get)
        return handler(...values)
      }
    }

    // return

    return styler
  }
}
